'use client';

import { Button } from '../../../core-components/Button';
import { Pictogram } from '../../../core-components/Pictogram';
import { useScreenNameAtLeast } from '../../../hooks/use-screen-name-at-least';
import { HeaderSection } from '../../shared/HeaderSection';

import type { PictogramName } from '../../../core-components/Pictogram';
import type { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

type Props = {
  pictogram?: PictogramName;
  headline?: string;
  subline?: ReactNode;
  signature?: ReactNode;
  cta?: ComponentPropsWithoutRef<typeof Button>;
  reset?: () => void;
  errorInfo?: string;
  errorDetail?: string;
};

export const DashboardError: FC<Props> = ({
  headline,
  subline,
  signature,
  pictogram,
  cta,
  errorInfo,
  errorDetail,
}) => {
  const isMdOrAbove = useScreenNameAtLeast('md');

  return (
    <div className="space-y-16">
      <div className="space-y-8 text-center">
        {(headline || subline) && (
          <div className="flex justify-center">
            <HeaderSection
              headline={headline}
              subline={subline}
              pictogram={isMdOrAbove ? 'not-available' : undefined}
            />
          </div>
        )}

        <div className="space-y-2 text-marine-100">
          <div>
            <Pictogram name={pictogram ?? 'ms-ship'} size="md" />
          </div>
          {signature && <div>{signature}</div>}
        </div>
      </div>

      {cta && (
        <div className="flex justify-center">
          <Button {...cta} variant="primary" />
        </div>
      )}

      <div>
        {errorInfo && (
          <div className="text-center text-sm text-marine-60">{errorInfo}</div>
        )}
        {errorDetail && (
          <div className="text-center text-sm text-error-100">
            Details: {errorDetail}
          </div>
        )}
      </div>
    </div>
  );
};
